<template>
  <div style=" width: 1200px; margin: 0 auto; background-color: #F2F6FC;  ">


<!--    <Title :title="route" ></Title>-->

    <Setp :nodes="nodes" :audits="audits"></Setp>

    <el-card class="box-card" style="min-height: 650px;margin-top: 15px" shadow="never">
      <el-form label-position="left" label-width="150px">

        <el-divider content-position="left">申请人信息</el-divider>

        <el-form-item label="申请人" prop="">
          <el-input v-model="user.realName" readonly></el-input>
        </el-form-item>

        <el-form-item label="所属部门" prop="">
          <el-input v-model="user.deptName" readonly></el-input>
        </el-form-item>


        <el-divider content-position="left">项目信息</el-divider>

        <el-tooltip class="item" effect="dark" content="该编号是暂时的，审核通过统一生成" placement="top" :disabled="audits.length === nodes.length">
          <el-form-item label="项目立项编号" prop="projectIden">
            <el-input v-model="detail.projectIden" readonly></el-input>
          </el-form-item>
        </el-tooltip>
        <el-form-item label="项目名称" prop="projectName">
          <el-input v-model="detail.projectName" readonly></el-input>
        </el-form-item>

        <el-form-item label="项目负责人" prop="managerName">
          <el-input v-model="detail.managerName" readonly></el-input>
        </el-form-item>

        <el-form-item label="项目预计金额" prop="projectAmountExpect">
          <el-input v-model="detail.projectAmountExpect" maxlength="12" readonly>
          </el-input>
        </el-form-item>

        <div v-for="(item,index) in surveys ">
          <!--            查询出所有项目概况  -->
          <el-form-item label="项目状态" prop="surveyState">
            <el-radio-group v-model="item.surveyState+''" style="cursor: not-allowed;pointer-events:none">
              <el-radio label="1">已沟通</el-radio>
              <el-radio label="2" disabled>已采购</el-radio>
              <el-radio label="3" disabled>已签约</el-radio>
              <el-radio label="4" disabled>已回款</el-radio>
              <el-radio label="5" disabled>已实施</el-radio>
              <el-radio label="6" disabled>项目终止</el-radio>
              <el-radio label="7" disabled>已完成</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="项目概况" prop="surveyBody">
            <el-input type="textarea" rows="5" maxlength="500" show-word-limit v-model="item.surveyBody"
                      readonly></el-input>
          </el-form-item>
        </div>

        <!--  查询出所有项目概况  -->
        <el-divider content-position="left">渠道信息</el-divider>

        <el-form-item label="是否通过渠道联系" prop="isChannel">
          <el-radio-group v-model="detail.isChannel" style="cursor: not-allowed;pointer-events:none">
            <el-radio label="1">是</el-radio>
            <el-radio label="2">否</el-radio>
          </el-radio-group>
        </el-form-item>

        <div v-if="detail.isChannel==1">
          <el-form-item label="渠道公司" prop="channelCompany">
            <el-input v-model="detail.channelCompany" readonly></el-input>
          </el-form-item>

          <el-form-item label="渠道联系人" prop="channelUserName">
            <el-input v-model="detail.channelUserName" readonly></el-input>
          </el-form-item>

          <el-form-item label="渠道联系人电话" prop="channelUserPhone">
            <el-input v-model="detail.channelUserPhone" readonly></el-input>
          </el-form-item>
        </div>

        <el-divider content-position="left">业主信息</el-divider>

        <el-form-item label="业主单位" prop="ownerCompany">
          <el-input v-model="detail.ownerCompany" readonly></el-input>
        </el-form-item>

        <el-form-item label="业主单位联系人" prop="ownerUserName">
          <el-input v-model="detail.ownerUserName" readonly></el-input>
        </el-form-item>

        <el-form-item label="业主单位联系人职位" prop="ownerUserPosition">
          <el-input v-model="detail.ownerUserPosition" readonly></el-input>
        </el-form-item>

        <el-form-item label="业主单位联系人电话" prop="ownerUserPhone">
          <el-input v-model="detail.ownerUserPhone" readonly></el-input>
        </el-form-item>

        <AuditList :audits="audits" :auditHistory="auditHistory"></AuditList>


        <div v-if="allowAudit==true">
          <el-divider content-position="left">我要审批</el-divider>


          <el-form-item label="审批意见" prop="remarks">
            <el-input type="textarea" rows="5" maxlength="500" show-word-limit
                      v-model="ruleForm.auditOpinion"></el-input>
          </el-form-item>


          <el-Form-item>
            <el-button type="primary" @click="audit(2)">审核通过</el-button>
            <el-button type="danger" @click="audit(3)">审核拒绝</el-button>
          </el-Form-item>
        </div>

      </el-form>


    </el-card>

    <el-dialog
        title="项目转移"
        :visible.sync="transferShow"
        width="30%"
    >
      <div v-if="shifts.length>0">
        <el-divider content-position="left">项目转移记录</el-divider>
        <div v-for="item in shifts" style="margin-bottom: 5px">
          <div>转移前负责人: {{ item.orgManagerName }}</div>
          <div>转移后负责人: {{ item.nowManagerName }}</div>
          <div>转移时间: {{ item.createTime }}</div>
        </div>
      </div>
      <el-divider content-position="left">我要转移</el-divider>
      <el-form label-position="top">
        <el-form-item label="转移前负责人" prop="contractName">
          <el-input v-model="localManagerName" readonly></el-input>
        </el-form-item>
        <el-form-item label="转移后负责人" prop="newProjectManager">
          <el-select v-model="newProjectManager" placeholder="请选择项目负责人" filterable style="width: 100%">
            <el-option
                v-for="item in sysUserList"
                :key="item.userId"
                :label='item.realName'
                :value="item.userId"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="transfer">开始转移</el-button>

        </el-form-item>
      </el-form>


    </el-dialog>
  </div>


</template>

<script>
import Title from "../../Title";
import {
  requestApplyDetail,
  requestAudit,
  requestAuditShow,
  requestProjectShiftRecord, requestShiftProjectManager,
  requestUserGet
} from "../../../api";
import AuditList from "../common/AuditList";
import Setp from "../common/Setp";
import {AesDecrypt} from "../../../util";

export default {
  components: {AuditList, Title, Setp},
  name: "ProjectDetail",
  props: {
    // 接收父组件传入的参数
    query: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      route: {
        name: '立项申请详情',
        path: ''
      },
      detail: {},
      audits: [],
      auditHistory: [],
      applyId: "",
      applyServiceId: "",
      applyType: "",
      surveys: [],
      /**/
      user: {},
      ruleForm: {
        auditOpinion: "",
      },
      nodes: [],
      allowAudit: false,

      transferShow: false,

      localManagerName: "",

      buttonArray: [],
      shifts: [],

      sysUserList: [],
      newProjectManager: "",
      loginUser: {},
    }
  },
  created() {
    // this.route.path = this.$route.fullPath
    this.applyId = this.query.applyId
    this.applyServiceId = this.query.applyServiceId
    this.applyType = this.query.applyType
    this.getObject()
    this.getAuditShow()
    this.initButton()
  },
  methods: {
    initButton() {
      const data = AesDecrypt(window.localStorage.getItem("user"))
      this.loginUser = JSON.parse(data)
      if (this.loginUser.roles.includes(1) || this.loginUser.roles.includes(4) || this.loginUser.roles.includes(6)) {
        this.buttonArray.push({
          type: 'primary',
          title: '项目转移',
          method: 'handleTransfer',
          disabled: false,
        })
      }
    },
    async loadSysUserData() {
      let res = await requestUserGet();
      if (res.code == 200) {
        this.sysUserList = res.object;
      } else {
        this.$message.error("获取人员列表失败")
      }
    },
    transfer() {
      if (!this.newProjectManager) {
        this.$message.error("请选择新的项目负责人");
        return
      }
      requestShiftProjectManager({
        projectId: this.detail.projectId,
        userId: this.newProjectManager,
      }).then(res => {
        if (res.code == 200) {
          this.$message.success(res.msg)
          this.getProjectShiftRecord()
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    getProjectShiftRecord() {
      requestProjectShiftRecord({
        projectId: this.detail.projectId,
      }).then(res => {
        if (res.code == 200) {
          if (res.object) {
            this.shifts = res.object
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    // 项目转移
    handleTransfer() {
      this.transferShow = true
      this.localManagerName = this.detail.managerName
      this.loadSysUserData()
      this.getProjectShiftRecord()

    },
    getAuditShow() {
      requestAuditShow({
        applyId: this.applyId,
      }).then(res => {
        if (res.code == 200) {
          if (res.object) {
            if (res.object == 1) {
              this.allowAudit = true
            }
            if (res.object == 2) {
              this.allowAudit = false
            }
          }
        }
      })
    },
    audit(isAgree) {

      this.allowAudit = false

      if (isAgree == 2 && !this.ruleForm.auditOpinion) {
        this.ruleForm.auditOpinion = "同意"
      }
      if (isAgree == 3 && !this.ruleForm.auditOpinion) {
        this.ruleForm.auditOpinion = "不同意"
      }

      requestAudit({
        isAgree: isAgree,
        applyId: this.applyId,
        applyType: this.applyType,
        auditOpinion: this.ruleForm.auditOpinion,
      }).then(res => {
        if (res.code == 200) {
          this.getAuditShow()
          this.getObject()
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    getObject() {
      requestApplyDetail({
        applyId: this.applyId,
        applyServiceId: this.applyServiceId,
        applyType: this.applyType
      }).then(res => {
        if (res.code == 200) {
          if (res.object) {
            this.detail = res.object.detail

            if (res.object.detail.isChannel) {
              this.detail.isChannel = res.object.detail.isChannel + ''
            }
            this.audits = res.object.audits
            this.auditHistory = res.object.auditHistory
            this.surveys = res.object.surveys
            this.user = res.object.user
            this.nodes = res.object.nodes
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    }
  }
}
</script>

<style>


</style>